import { gql } from "@apollo/client";

const UploadsQuery = gql`
  query AllUploads($userId: UUID!) {
    allUploads(condition: { userId: $userId }, orderBy: UPLOADED_DESC) {
      nodes {
        projectName
        imageCount
        id
        status
        uploaded
        zipFileName
        zipFileSize
        imageCount
        isBulk
        failedFilesByUploadId {
          totalCount
        }
      }
    }
  }
`;

const hash = "eac0564a1f5f2cc201d3e9428f03a45f9fb936af4f404af7774398c6e09bf68a";

export { UploadsQuery, hash };
